import { Duration } from 'luxon';
import React, { useEffect, useRef, useState } from 'react';
import styles from '../styles/timeElapsed.scss';
const getSecondsElapsed = (start) => {
    const now = Date.now();
    return start ? Math.floor((now - start) / 1000) : 0;
};
const formatTime = (secondsElapsed) => {
    return Duration.fromObject({ seconds: secondsElapsed }).toFormat('hh:mm:ss');
};
const TimeElapsed = ({ start, autoUpdate }) => {
    const [secondsElapsed, setSecondsElapsed] = useState(getSecondsElapsed(start));
    const interval = useRef();
    useEffect(() => {
        if (autoUpdate) {
            interval.current = setInterval(() => {
                const elapsed = getSecondsElapsed(start);
                setSecondsElapsed(elapsed);
            }, 100);
        }
        return () => {
            if (interval.current) {
                clearInterval(interval.current);
            }
        };
    }, [autoUpdate, start]);
    return React.createElement("time", { className: styles.time }, formatTime(secondsElapsed));
};
export default TimeElapsed;
